var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModalEditar", {
        attrs: {
          titulo: "Editar Envío de Información",
          form: Object.values(_vm.pasos).find(function(x) {
            return x.step === _vm.pasoActivoIndex
          }).formState,
          pasos: _vm.pasos,
          entidad: "Envío de Información",
          estadoEntidad: _vm.estadoEntidad,
          inactivable: _vm.modificable,
          nombreEntidad: "",
          pasoActivoIndex: _vm.pasoActivoIndex,
          mensajeInactivo: _vm.mensajeInactivo
        },
        on: {
          cerrar: _vm.handleCerrar,
          guardar: _vm.handleGuardar,
          inactivo: _vm.handleInactivo
        }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("InformacionGeneralForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex === _vm.pasos.informacionGeneral.step,
                expression: "pasoActivoIndex === pasos.informacionGeneral.step"
              }
            ],
            attrs: { envio: _vm.envio, modoEditar: true },
            on: { change: _vm.handleFormChange }
          }),
          _c("AsociarFlotaEtiquetaVehiculoIndividual", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pasoActivoIndex === _vm.pasos.asociarVehiculos.step,
                expression: "pasoActivoIndex === pasos.asociarVehiculos.step"
              }
            ],
            attrs: {
              "flotas-id-seleccionar": _vm.envio && _vm.envio.flotas,
              "etiquetas-id-seleccionar": _vm.envio && _vm.envio.etiquetas,
              "vehiculos-id-seleccionar": _vm.envio && _vm.envio.vehiculos,
              "col-def-vehiculo": _vm.vehiculoColDefs,
              esEditar: true
            },
            on: { change: _vm.handleAsociacionesChange }
          })
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.permiteContinuarConfirm,
          titulo: _vm.tituloPermiteContinuar,
          mensaje: _vm.mensajePermiteContinuar,
          items: _vm.itemsNoValidos,
          mostrarBoton: false
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.permiteContinuarConfirm = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }